import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {Setting} from '../../shared/models/setting.model';
import {ToolsService} from '../../shared/services/tools.service';
import {UploadService} from '../../shared/services/upload.service';
import {Upload} from '../../shared/models/upload.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'form-setting',
    templateUrl: 'form-setting.html'
})

export class FormSettingComponent implements OnInit, OnDestroy {

    @Input() settings: Setting;

    uploads_new: Upload[] = [];

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private dataStorageService: DataStorageService,
                private toolsService: ToolsService,
                private uploadService: UploadService) {
    }

    settingForm: FormGroup;

    ngOnInit() {
        this.uploadService.uploadSub.pipe(takeUntil(this.unsubscribe$)).subscribe(
            upload => {
                this.uploads_new.push(upload);
            }
        );

        this.initForm();
    }

    initForm() {
        this.settingForm = new FormGroup({
            'company_name': new FormControl(this.settings.company_name),
            'company_email': new FormControl(this.settings.company_email),
            'company_phone': new FormControl(this.settings.company_phone),
            'company_address': new FormControl(this.settings.company_address),
            'company_shuttle_phone': new FormControl(this.settings.company_shuttle_phone),
            'text_page_home_title': new FormControl(this.settings.text_page_home_title),
            'text_page_home': new FormControl(this.settings.text_page_home),
            'text_page_home_sec': new FormControl(this.settings.text_page_home_sec),
            'text_page_home_thr': new FormControl(this.settings.text_page_home_thr),
            'text_page_coupon': new FormControl(this.settings.text_page_coupon),
            'text_page_coupon_ewr': new FormControl(this.settings.text_page_coupon_ewr),
            'text_page_book': new FormControl(this.settings.text_page_book),
            'text_email_header': new FormControl(this.settings.text_email_header),
            'text_email_footer': new FormControl(this.settings.text_email_footer),
            'text_email_confirm': new FormControl(this.settings.text_email_confirm),
            'text_email_reconfirm': new FormControl(this.settings.text_email_reconfirm),
            'text_email_register': new FormControl(this.settings.text_email_register),
            'text_ad': new FormControl(this.settings.text_ad),
            'text_notice_popup': new FormControl(this.settings.text_notice_popup),
            'is_cron': new FormControl(this.settings.is_cron),
            'access_time_from': new FormControl(this.settings.access_time_from),
            'access_time_to': new FormControl(this.settings.access_time_to),
        });
    }

    onSubmit() {
        const value = this.settingForm.value;
        const newSetting = new Setting(1,
            value.company_name, value.company_email, value.company_phone,
            value.company_address, value.company_shuttle_phone,
            value.text_page_home_title, value.text_page_home, value.text_page_home_sec, value.text_page_home_thr,
            value.text_page_coupon, value.text_page_book,
            value.text_email_header, value.text_email_footer,
            value.text_email_confirm, value.text_email_reconfirm, value.text_email_register,
            value.text_ad, value.is_cron, value.access_time_from, value.access_time_to);
        // Set EWR text as a property to avoid positional clash with the `upload` constructor arg
        newSetting.text_page_coupon_ewr = value.text_page_coupon_ewr;
        // Reservation page popup notice (same pattern as EWR text above)
        newSetting.text_notice_popup = value.text_notice_popup;
        this.dataStorageService.updateSetting(newSetting)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(responseData => {
            if (responseData['error']) {
                alert('updating settings error');
            } else {
                alert('settings updated. ');
                this.dataStorageService.fetchSetting().pipe(takeUntil(this.unsubscribe$)).subscribe();
            }
        });
    }

    onUpload() {
        this.uploadService.uploadProcessEmitter.emit({'type': 'setting', id: 1});
    }

    onDeleteUpload(id: number, name: string) {
        this.dataStorageService.deleteUpload(id, name).pipe(takeUntil(this.unsubscribe$)).subscribe(
            responseData => {
                if (responseData['status'] === '200') {
                    console.log(responseData);
                    let index = 0;
                    if (this.settings.upload.findIndex(upload => upload.id === id) !== null) {
                        index = this.settings.upload.findIndex(upload => upload.id === id);
                        this.settings.upload.splice(index, 1);
                    } else {
                        index = this.uploads_new.findIndex(upload => upload.id === id);
                        this.uploads_new.splice(index, 1);
                    }
                } else if (responseData['status'] === '405') {
                    console.log('not done');
                }
            }
        );
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
